export const INITIAL = {
	TAB: 0,
	MODAL: {
		content: '',
		data: {
			shape: {}
		}
	},
	VALUES: {
		id: 0,
		life: 0,
		damage: 0,
		strength: 0,
		dexterity: 0,
		constitution: 0,
		intelligence: 0,
		wisdom: 0,
		charisma: 0,
		shape: {}
	},
	LIST: {},
}